
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/rEditor/rootComps/stage/stageLayerExtensionSlot/stageLayerExtensionSlot.scss.css.virtualfile';
        module.exports = {"container":"_container_1oxwx_1","mobile":"_mobile_1oxwx_6"};